import DatahubAPI from '../../api/DatahubAPI';
import { EXPORT_COMMODITY_LENSES } from 'api/ExportHubAPI';

/**
 * Fetches the BITE commodity lenses available to screen against, using the SAME
 * source the standalone Export Screening tool uses: a Datahub OpenSearch
 * aggregation over the commodities index. See
 * `components/Screening/mainTabComponents/Commodities.tsx` (`initialAPICall` /
 * `filtersAggQuery`) — the lens list is `listAgg.buckets[].key`.
 *
 * This deliberately does NOT include the separate "HTS Code List" options
 * (`hsCodeListOpts`, sourced from the `bite_app_commodities_nomenclature`
 * `listName` aggregation) — those are a different filter dimension in the
 * Export Screening tool and are not lenses.
 *
 * On any failure (Datahub down, empty aggregation) it falls back to the static
 * EXPORT_COMMODITY_LENSES so the picker is never empty/unusable.
 */
export async function fetchExportCommodityLenses(): Promise<string[]> {
  try {
    const res = await DatahubAPI.commoditySearch({
      indices: ['bite_app_commodities_*'],
      tradeType: 'US Import',
      type: 'Export',
      agg: true,
    });
    const buckets: Array<{ key?: string }> =
      res?.result?.result?.body?.aggregations?.listAgg?.buckets || [];
    const seen = new Set<string>();
    const lenses: string[] = [];
    buckets.forEach((b) => {
      const key = String(b?.key ?? '').trim();
      if (key && !seen.has(key)) {
        seen.add(key);
        lenses.push(key);
      }
    });
    return lenses.length ? lenses : [...EXPORT_COMMODITY_LENSES];
  } catch {
    return [...EXPORT_COMMODITY_LENSES];
  }
}

export default fetchExportCommodityLenses;
